import { Component, OnInit, ViewChild } from '@angular/core';
import { ManufacturerService } from '../manufacturer.service';
import { Router } from '@angular/router';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';
import { MatTableDataSource } from '@angular/material/table';
import { Manufacturer } from 'src/app/entity/manufacturer';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manufacturer-table-view',
  templateUrl: './manufacturer-table-view.component.html',
  styleUrls: ['./manufacturer-table-view.component.scss'],
})
export class ManufacturerTableViewComponent implements OnInit {
  manufacturers: MatTableDataSource<Manufacturer>;
  displayedColumns: string[] = ['name', 'unitelId', 'active'];

  constructor(
    private router: Router,
    private manufacturerService: ManufacturerService,
    private snackService: SnackbarService
  ) {}

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit(): void {
    this.manufacturers = new MatTableDataSource<Manufacturer>();
    this.getManufacturers();

    if (this.manufacturers !== undefined) {
      this.manufacturers.sort = this.sort;
    }
  }

  updateManufacturerList(): void {
    this.manufacturerService.updateManufacturerList().subscribe(
      (res) => {
        this.snackService.open('manufacturer.response.updated', 4, 'success');
        this.getManufacturers();
      },
      (error) => {
        this.snackService.open(
          'manufacturer.response.updateError',
          6,
          'failed'
        );
      }
    );
  }

  getManufacturers(): void {
    this.manufacturerService.getManufacturer().subscribe((res) => {
      this.manufacturers.data = res;
      console.log(res);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.manufacturers.filter = filterValue.trim().toLowerCase();
  }

  changeActivation(row: Manufacturer) {
    this.manufacturerService.updpateManufacturerState(row).subscribe(
      (res) => {
        if (row.active) {
          this.snackService.open(
            'manufacturer.response.activated',
            4,
            'success'
          );
        } else {
          this.snackService.open(
            'manufacturer.response.deactivated',
            4,
            'success'
          );
        }
      },
      (error) => {
        this.snackService.open(
          'manufacturer.response.updateError',
          6,
          'failed'
        );
      }
    );
  }
}
